import { baseApiV2 } from '@verantos-dev/app-state-base';
import {
  ExportCohortResponseType,
  ExportConnectionDetailsType,
  ExportCohortPayloadType,
} from '@verantos-dev/types-cohorts';
import { ObjectResponse } from '@verantos-dev/types-common';

import { EXPORT_CONNECTIONS_BASE_PATH, EXPORT_CONNECTIONS_TAG } from './constants';

const exportConnectionsApiSlice = baseApiV2
  .enhanceEndpoints({
    addTagTypes: [EXPORT_CONNECTIONS_TAG],
  })
  .injectEndpoints({
    endpoints: (builder) => ({
      getExportConnections: builder.query<
        Array<ExportConnectionDetailsType>,
        { organizationId: string }
      >({
        query: ({ organizationId }) =>
          `/${EXPORT_CONNECTIONS_BASE_PATH}/?organization_id=${organizationId}`,
      }),
      exportCohort: builder.mutation<
        ObjectResponse<ExportCohortResponseType>,
        ExportCohortPayloadType
      >({
        query: ({ projectId, cohortId, data }) => ({
          url: `/projects/${projectId}/cohort-profile/${cohortId}/export`,
          method: 'POST',
          body: data,
        }),
      }),
    }),
  });

export const { useGetExportConnectionsQuery, useExportCohortMutation } = exportConnectionsApiSlice;
